import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  teams: []
}

const mutations = {  
  SET_TEAMS (state, payload) {
    state.teams = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  teamList: (context, id) => {
    return Vue.http.get(`${env.API}/api/team`)    
      .then((response) => {        
        context.commit('SET_TEAMS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getTeams: (state) => state.teams
}

export const team = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/team.js